var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCybersecurity3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#0464A4",
    fillOpacity: 0.094
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 20.8334C26.6666 25 23.75 27.0834 20.2833 28.2917C20.1018 28.3532 19.9046 28.3503 19.725 28.2834C16.25 27.0834 13.3333 25 13.3333 20.8334V15C13.3333 14.779 13.4211 14.5671 13.5774 14.4108C13.7337 14.2545 13.9456 14.1667 14.1666 14.1667C15.8333 14.1667 17.9166 13.1667 19.3666 11.9C19.5432 11.7492 19.7678 11.6663 20 11.6663C20.2322 11.6663 20.4568 11.7492 20.6333 11.9C22.0916 13.175 24.1666 14.1667 25.8333 14.1667C26.0543 14.1667 26.2663 14.2545 26.4226 14.4108C26.5788 14.5671 26.6666 14.779 26.6666 15V20.8334Z",
    stroke: "#0464A4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurity3);
export default __webpack_public_path__ + "static/media/Cybersecurity (3).5b47af53c94d6163034a263a1e26fa1e.svg";
export { ForwardRef as ReactComponent };